<app-header text="header.reset_password"></app-header>
<app-header-caption text="header.reset_password_caption"></app-header-caption>
<app-registration-form btnText="header.reset_password" [submitFn]="submitFn"></app-registration-form>
